module.exports = __webpack_public_path__ + "img/daren_9.915ce18f.png";